import Icon from '../components/Icon.vue'

Icon.register({
  'file-import': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M16 288h112v64h-112c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM505 105c4.5 4.5 7 10.6 7 16.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7zM352 136c0 13.2 10.8 24 24 24h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-136h127.9v65.1c0 14.3 17.3 21.4 27.4 11.3l95.7-96.4c6.6-6.6 6.6-17.3 0-24l-95.6-96.5c-10.1-10.1-27.4-3-27.4 11.3v65.2h-128v-264c0-13.3 10.7-24 24-24h200v136z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-import.js
// module id = 1337
// module chunks = 0